import { render, staticRenderFns } from "./SArticleCate.vue?vue&type=template&id=819b4be4&scoped=true"
import script from "./SArticleCate.vue?vue&type=script&lang=js"
export * from "./SArticleCate.vue?vue&type=script&lang=js"
import style0 from "./SArticleCate.vue?vue&type=style&index=0&id=819b4be4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819b4be4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819b4be4')) {
      api.createRecord('819b4be4', component.options)
    } else {
      api.reload('819b4be4', component.options)
    }
    module.hot.accept("./SArticleCate.vue?vue&type=template&id=819b4be4&scoped=true", function () {
      api.rerender('819b4be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/editor/modules/SArticleCate.vue"
export default component.exports